import { render, staticRenderFns } from "./bigDatah.vue?vue&type=template&id=36ce3cf4&"
import script from "./bigDatah.vue?vue&type=script&lang=js&"
export * from "./bigDatah.vue?vue&type=script&lang=js&"
import style0 from "./bigDatah.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports